import $http from '@/libs/axios'

export default class ChatBotApi {
  static async fetchByKeyword(pageId: any, data: any) {
    return (await $http.post(`chatbot/reply/by-keyword/${pageId}`, data)).data
  }

  static async addReply(pageId: any, data: any) {
    return (await $http.post(`chatbot/reply/add/${pageId}`, data)).data
  }

  static async deleteBot(pageId: any, botId: any, isDirect = 0) {
    return (await $http.post(`chatbot/reply/delete/${pageId}/${botId}`, { is_direct: isDirect })).data
  }

  static async deleteFlow(id: string) {
    return (await $http.delete(`chatbot/flow/campaigns/${id}`)).data
  }

  static async uploadFile(data: any) {
    return (await $http.post('chatbot/file/upload/', data)).data
  }

  static async deleteFile(url: string) {
    return (await $http.post('chatbot/file/delete', { file: url })).data
  }

  static async addLegacyReply(data: any, pageId: number) {
    return (await $http.post(`chatbot/legacy/reply/add/${pageId}`, data)).data
  }

  static async deleteSubscriber(pageId: number, id: string) {
    return (await $http.delete(`chatbot/subscribers/destroy/${pageId}/${id}`)).data
  }

  static async enableDisableBot(pageId: number) {
    return (await $http.get(`chatbot/settings/toggle/${pageId}`)).data
  }

  static async enableDisableInstagramBot(pageId: number, accountId: any) {
    return (await $http.get(`chatbot/instagram/settings/toggle/${pageId}/${accountId}`)).data
  }
}
